import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import "./index.css";
import App from "./App";
import LoadingScreen from "./components/LoadingScreen";
import reportWebVitals from "./reportWebVitals";

// NOTE: ClerkProvider intentionally NO LONGER lives here. Mounting it at the
// root booted clerk-js + a clerk.adstronaut.net handshake on every public page
// (home, blogs, all landing pages), wasting crawl budget. It now wraps only the
// auth-gated routes via <ClerkBoundary> in App.js. Public pages read sign-in
// state from the __client_uat cookie (src/hooks/useSessionHint.js).
// ── Version-skew guard ───────────────────────────────────────────────────
// With route code-splitting, a tab left open across a deploy can request a
// lazy chunk whose hashed filename no longer exists (each Vercel deployment
// only serves its own hashes) → ChunkLoadError and a dead navigation. On
// that specific failure, reload once: the fresh index.html references the
// new hashes and the navigation succeeds. A sessionStorage timestamp guard
// prevents reload loops during a genuine outage; users just see one normal
// page load instead of a broken screen.
const isChunkLoadError = (reason) => {
  const msg = String(reason?.message || reason || "");
  return (
    reason?.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk [\S]+ failed/i.test(msg) ||
    /Failed to fetch dynamically imported module/i.test(msg)
  );
};
const reloadOnceForChunkError = () => {
  try {
    const KEY = "chunkErrorReloadedAt";
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 60 * 1000) return; // already tried — don't loop
    sessionStorage.setItem(KEY, String(Date.now()));
    window.location.reload();
  } catch (e) { /* storage unavailable — let the error surface normally */ }
};
window.addEventListener("unhandledrejection", (event) => {
  if (isChunkLoadError(event.reason)) {
    event.preventDefault();
    reloadOnceForChunkError();
  }
});
window.addEventListener("error", (event) => {
  if (isChunkLoadError(event.error || event.message)) {
    reloadOnceForChunkError();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
